(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veruca-app-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var button = document.getElementById('VerucaAppButton');
    var modal = document.getElementById('VerucaAppModal');
    if (!button || !modal) return;

    var ua = window.navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.indexOf('Macintosh') !== -1 && 'ontouchend' in document);
    var isAndroid = /Android/.test(ua);
    var platform = isIOS ? 'ios' : (isAndroid ? 'android' : 'desktop');

    Array.prototype.forEach.call(modal.querySelectorAll('[data-veruca-steps]'), function (el) {
      el.hidden = el.getAttribute('data-veruca-steps') !== platform;
    });

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.veruca-app-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
      button.focus();
    }

    button.addEventListener('click', openModal);

    Array.prototype.forEach.call(modal.querySelectorAll('[data-veruca-close]'), function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
